var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 95,
    viewBox: "0 0 108 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1429 23.75C61.2 13.9402 50.9143 6.71196 42.1714 10.8424C40.6286 4.64674 34.9714 0 28.2857 0C19.0286 0 12.3429 7.74457 12.8571 16.5217C5.65714 17.038 0 23.2337 0 30.462C0 38.2065 6.17143 44.4022 13.8857 44.4022H59.6571C65.3143 44.4022 69.9429 39.7554 69.9429 34.0761C69.9429 28.3967 65.8286 23.75 59.1429 23.75Z",
    fill: "url(#paint0_linear_57_115)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M66.8569 27.8804C52.4569 27.8804 41.1426 39.2391 41.1426 53.6956C41.1426 68.1522 52.4569 79.5109 66.8569 79.5109C81.2569 79.5109 92.5711 68.1522 92.5711 53.6956C92.5711 39.7554 81.2569 27.8804 66.8569 27.8804Z",
    fill: "url(#paint1_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M66.8569 27.8804C52.9711 27.8804 41.1426 39.2391 41.1426 53.6956C41.1426 67.6359 52.4569 79.5109 66.8569 79.5109C80.7426 79.5109 92.5711 68.1522 92.5711 53.6956C92.5711 39.7554 80.7426 27.8804 66.8569 27.8804Z",
    fill: "url(#paint2_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M66.8572 28.3967C52.9715 28.3967 41.6572 39.7554 41.6572 53.6957C41.6572 67.6359 52.9715 78.9946 66.8572 78.9946C80.7429 78.9946 92.0572 67.6359 92.0572 53.6957C92.0572 39.7554 80.7429 28.3967 66.8572 28.3967Z",
    fill: "url(#paint3_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M66.8572 28.3967C52.9715 28.3967 41.6572 39.7554 41.6572 53.1793C41.6572 67.1196 52.9715 78.4783 66.8572 78.4783C80.7429 78.4783 92.0572 67.1196 92.0572 53.1793C92.0572 39.7554 80.7429 28.3967 66.8572 28.3967Z",
    fill: "url(#paint4_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M67.3713 28.3967C53.9998 28.3967 42.6855 39.2391 42.6855 53.1793C42.6855 66.6033 53.4855 77.962 67.3713 77.962C80.7427 77.962 92.057 67.1196 92.057 53.1793C92.057 39.7554 80.7427 28.3967 67.3713 28.3967Z",
    fill: "url(#paint5_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M67.3711 28.913C53.9997 28.913 43.1997 39.7554 43.1997 53.1793C43.1997 66.6033 53.9997 77.4456 67.3711 77.4456C80.7426 77.4456 91.5426 66.6033 91.5426 53.1793C91.5426 39.7554 80.7426 28.913 67.3711 28.913Z",
    fill: "url(#paint6_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M67.3711 28.913C53.9997 28.913 43.1997 39.7554 43.1997 53.1793C43.1997 66.6033 53.9997 77.4456 67.3711 77.4456C80.7426 77.4456 91.5426 66.6033 91.5426 53.1793C91.5426 39.7554 80.7426 28.913 67.3711 28.913Z",
    fill: "url(#paint7_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.3715 28.913C54.0001 28.913 43.7144 39.7554 43.7144 52.663C43.7144 66.087 54.5144 76.413 67.3715 76.413C80.7429 76.413 91.0287 65.5707 91.0287 52.663C91.0287 39.7554 80.7429 28.913 67.3715 28.913Z",
    fill: "url(#paint8_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M67.3715 28.913C54.5144 28.913 43.7144 39.2391 43.7144 52.663C43.7144 65.5707 54.0001 76.413 67.3715 76.413C80.2286 76.413 91.0287 66.087 91.0287 52.663C91.0287 39.7554 80.2286 28.913 67.3715 28.913Z",
    fill: "url(#paint9_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M67.3714 29.4293C54.5142 29.4293 44.2285 39.7554 44.2285 52.663C44.2285 65.5707 54.5142 75.8967 67.3714 75.8967C80.2285 75.8967 90.5142 65.5707 90.5142 52.663C91.0285 39.7554 80.2285 29.4293 67.3714 29.4293Z",
    fill: "url(#paint10_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M67.3714 29.4293C54.5142 29.4293 44.2285 39.7554 44.2285 52.663C44.2285 65.5707 54.5142 75.8967 67.3714 75.8967C80.2285 75.8967 90.5142 65.5707 90.5142 52.663C90.5142 39.7554 80.2285 29.4293 67.3714 29.4293Z",
    fill: "url(#paint11_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M67.8854 29.4293C55.5425 29.4293 45.2568 39.7554 45.2568 52.1467C45.2568 64.5381 55.5425 74.8641 67.8854 74.8641C80.2283 74.8641 90.514 64.5381 90.514 52.1467C90.514 39.7554 80.2283 29.4293 67.8854 29.4293Z",
    fill: "url(#paint12_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M67.8854 29.4293C55.5425 29.4293 45.2568 39.7554 45.2568 52.1467C45.2568 64.5381 55.5425 74.8641 67.8854 74.8641C80.2283 74.8641 90.514 64.5381 90.514 52.1467C89.9997 39.7554 80.2283 29.4293 67.8854 29.4293Z",
    fill: "url(#paint13_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M67.8858 29.9457C55.5429 29.9457 45.7715 39.7554 45.7715 52.1467C45.7715 64.538 55.5429 74.3478 67.8858 74.3478C80.2286 74.3478 90 64.538 90 52.1467C90 39.7554 80.2286 29.9457 67.8858 29.9457Z",
    fill: "url(#paint14_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M67.8856 29.9457C56.0571 29.9457 46.2856 39.7554 46.2856 51.6304C46.2856 63.5054 56.0571 73.3152 67.8856 73.3152C79.7142 73.3152 89.4856 63.5054 89.4856 51.6304C89.9999 39.7554 80.2285 29.9457 67.8856 29.9457Z",
    fill: "url(#paint15_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M67.8857 29.9457C56.0571 29.9457 46.2856 39.7554 46.2856 51.6304C46.2856 63.5054 56.0571 73.3152 67.8857 73.3152C79.7142 73.3152 89.4857 63.5054 89.4857 51.6304C89.4857 39.7554 79.7142 29.9457 67.8857 29.9457Z",
    fill: "url(#paint16_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M66.8568 29.4293C68.914 29.4293 70.4568 27.8804 70.4568 26.3315V16.5217C70.4568 14.9728 68.914 13.4239 66.8568 13.4239C64.7997 13.4239 63.2568 14.9728 63.2568 16.5217V26.3315C63.2568 27.8804 64.7997 29.4293 66.8568 29.4293Z",
    fill: "url(#paint17_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M66.8568 29.4293C68.914 29.4293 70.4568 27.8804 70.4568 26.3315V16.5217C70.4568 14.9728 68.914 13.4239 66.8568 13.4239C64.7997 13.4239 63.2568 14.9728 63.2568 16.5217V25.8152C63.2568 27.8804 64.7997 29.4293 66.8568 29.4293Z",
    fill: "url(#paint18_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M66.8568 28.913C68.914 28.913 70.4568 27.3641 70.4568 25.8152V16.5217C70.4568 14.9728 68.914 13.4239 66.8568 13.4239C64.7997 13.4239 63.2568 14.9728 63.2568 16.5217V25.8152C63.7711 27.3641 65.314 28.913 66.8568 28.913Z",
    fill: "url(#paint19_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M66.8568 28.913C68.914 28.913 70.4568 27.3641 70.4568 25.8152V16.5217C70.4568 14.9728 68.914 13.4239 66.8568 13.4239C64.7997 13.4239 63.2568 14.9728 63.2568 16.5217V25.8152C63.7711 27.3641 65.314 28.913 66.8568 28.913Z",
    fill: "url(#paint20_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M67.3709 28.3967C69.4281 28.3967 70.4566 26.8478 70.4566 25.2989V16.5217C70.4566 14.9728 68.9138 13.4239 67.3709 13.4239C65.3138 13.4239 64.2852 14.9728 64.2852 16.5217V25.8152C63.7709 26.8478 65.3138 28.3967 67.3709 28.3967Z",
    fill: "url(#paint21_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M67.3709 27.8804C68.9138 27.8804 70.4566 26.3315 70.4566 24.7826V16.0054C70.4566 14.4565 68.9138 12.9076 67.3709 12.9076C65.8281 12.9076 64.2852 14.4565 64.2852 16.0054V24.7826C63.7709 26.8478 65.3138 27.8804 67.3709 27.8804Z",
    fill: "url(#paint22_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M67.3714 27.8804C68.9142 27.8804 70.4571 26.3315 70.4571 24.7826V16.0054C70.4571 14.4565 68.9142 12.9076 67.3714 12.9076C65.8285 12.9076 64.2856 14.4565 64.2856 16.0054V24.7826C64.2856 26.3315 65.8285 27.8804 67.3714 27.8804Z",
    fill: "url(#paint23_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.3714 27.3641C68.9142 27.3641 70.4571 26.3315 70.4571 24.2663V16.0054C70.4571 14.4565 68.9142 12.9076 67.3714 12.9076C65.8285 12.9076 64.2856 13.9402 64.2856 16.0054V24.7826C64.2856 26.3315 65.8285 27.3641 67.3714 27.3641Z",
    fill: "url(#paint24_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M67.3714 27.3641C68.9142 27.3641 70.4571 26.3315 70.4571 24.7826V16.0054C70.4571 14.4565 68.9142 13.4239 67.3714 13.4239C65.8285 13.4239 64.2856 14.4565 64.2856 16.0054V24.2663C64.2856 25.8152 65.8285 27.3641 67.3714 27.3641Z",
    fill: "url(#paint25_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M67.3714 26.8478C68.9142 26.8478 70.4571 25.8152 70.4571 24.2663V16.0054C70.4571 14.4565 68.9142 13.4239 67.3714 13.4239C65.8285 13.4239 64.2856 14.4565 64.2856 16.0054V24.2663C64.7999 25.8152 65.8285 26.8478 67.3714 26.8478Z",
    fill: "url(#paint26_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M67.3712 26.8478C68.9141 26.8478 69.9427 25.8152 69.9427 24.2663V16.0054C69.9427 14.4565 68.9141 13.4239 67.3712 13.4239C65.8284 13.4239 64.7998 14.4565 64.7998 16.0054V24.2663C64.7998 25.2989 65.8284 26.8478 67.3712 26.8478Z",
    fill: "url(#paint27_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M67.8852 26.3315C69.428 26.3315 70.4566 25.2989 70.4566 23.75V16.0054C70.4566 14.4565 69.428 13.4239 67.8852 13.4239C66.3423 13.4239 65.3138 14.4565 65.3138 16.0054V23.75C64.7995 25.2989 66.3423 26.3315 67.8852 26.3315Z",
    fill: "url(#paint28_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M67.8854 25.8152C69.4282 25.8152 70.4568 24.7826 70.4568 23.2337V16.0054C70.4568 14.4565 69.4282 13.4239 67.8854 13.4239C66.3425 13.4239 65.314 14.4565 65.314 16.0054V23.75C65.314 24.7826 66.3425 25.8152 67.8854 25.8152Z",
    fill: "url(#paint29_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M67.8854 25.8152C69.4282 25.8152 70.4568 24.7826 70.4568 23.2337V15.4891C70.4568 13.9402 69.4282 12.9076 67.8854 12.9076C66.3425 12.9076 65.314 13.9402 65.314 15.4891V23.2337C65.314 24.7826 66.3425 25.8152 67.8854 25.8152Z",
    fill: "url(#paint30_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M67.8854 25.2989C69.4282 25.2989 70.4568 24.2663 70.4568 22.7174V15.4891C70.4568 13.9402 69.4282 12.9076 67.8854 12.9076C66.3425 12.9076 65.314 13.9402 65.314 15.4891V22.7174C65.314 24.2663 66.3425 25.2989 67.8854 25.2989Z",
    fill: "url(#paint31_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M67.8854 25.2989C69.4282 25.2989 70.4568 24.2663 70.4568 22.7174V15.4891C70.4568 13.9402 69.4282 12.9076 67.8854 12.9076C66.3425 12.9076 65.314 13.9402 65.314 15.4891V22.7174C65.8283 24.2663 66.8568 25.2989 67.8854 25.2989Z",
    fill: "url(#paint32_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M49.8855 37.1739C51.4283 35.625 51.4283 33.5598 49.8855 32.5272L43.1998 25.2989C41.6569 24.2663 39.5998 24.2663 38.5712 25.8152C37.0283 27.3641 37.0283 29.4294 38.5712 30.462L45.2569 37.1739C46.2855 38.7228 48.3426 38.7228 49.8855 37.1739Z",
    fill: "url(#paint33_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M49.8855 37.1739C51.4283 35.625 51.4283 33.5598 49.8855 32.5272L43.1998 25.2989C42.1712 24.2663 40.1141 24.2663 38.5712 25.8152C37.0283 27.3641 37.0283 29.4294 38.5712 30.462L45.2569 37.1739C46.2855 38.7228 48.3426 38.2065 49.8855 37.1739Z",
    fill: "url(#paint34_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M49.8855 36.6576C51.4283 35.1087 51.4283 33.0435 49.8855 32.0109L43.1998 25.2989C42.1712 24.2663 40.1141 24.2663 38.5712 25.8152C37.0283 27.3641 37.0283 29.4294 38.5712 30.462L45.2569 37.1739C46.2855 38.2065 48.3426 38.2065 49.8855 36.6576Z",
    fill: "url(#paint35_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M49.8859 36.6576C51.4287 35.1087 51.4287 33.0435 49.8859 32.0109L43.2001 25.2989C42.1716 24.2663 40.1144 24.2663 39.0859 25.8152C37.543 27.3641 37.543 29.4294 39.0859 30.462L45.7716 37.1739C46.2859 37.6902 48.343 37.6902 49.8859 36.6576Z",
    fill: "url(#paint36_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M49.8856 36.1413C50.9141 35.1087 51.4284 33.0435 49.8856 31.4946L43.7141 25.2989C42.1713 24.2663 40.1141 24.2663 39.0856 25.8152C38.057 26.8478 37.5427 28.913 39.0856 30.462L45.257 36.6576C46.2856 37.6902 48.3427 37.6902 49.8856 36.1413Z",
    fill: "url(#paint37_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M49.8854 36.1413C50.914 35.1087 51.4283 33.0435 49.8854 32.0109L43.714 25.2989C42.6854 24.2663 40.6283 24.2663 39.5997 25.2989C38.5711 26.3315 38.0569 28.3967 39.5997 29.4294L45.2569 36.1413C46.2854 37.1739 48.3426 37.1739 49.8854 36.1413Z",
    fill: "url(#paint38_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M49.8858 35.625C50.9143 34.5924 50.9143 32.5272 49.8858 31.4946L43.7143 25.2989C42.6858 24.2663 40.6286 24.2663 39.6 25.2989C38.5715 26.3315 38.5715 28.3967 39.6 29.4293L45.2572 36.1413C46.2858 37.1739 48.3429 37.1739 49.8858 35.625Z",
    fill: "url(#paint39_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.8858 35.625C50.9143 34.5924 50.9143 32.5272 49.8858 31.4946L43.7143 25.2989C42.6858 24.2663 40.6286 24.2663 39.6 25.2989C38.5715 26.3315 38.5715 28.3967 39.6 29.4293L45.7715 35.625C46.8 36.6576 48.3429 36.6576 49.8858 35.625Z",
    fill: "url(#paint40_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M49.3715 35.1087C50.4 34.0761 50.4 32.0109 49.3715 30.9783L43.7143 25.2989C42.6858 24.2663 41.1429 24.2663 39.6 25.2989C38.5715 26.3315 38.5715 28.3967 39.6 29.4293L45.7715 35.625C46.8 36.6576 48.3429 36.6576 49.3715 35.1087Z",
    fill: "url(#paint41_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M49.3713 35.1087C50.3999 34.0761 50.3999 32.0109 49.3713 30.9783L43.7142 25.2989C42.6856 24.2663 41.1428 24.2663 40.1142 25.2989C39.0856 26.3315 39.0856 28.3967 40.1142 29.4293L45.7713 35.1087C46.7999 36.1413 48.3428 36.1413 49.3713 35.1087Z",
    fill: "url(#paint42_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M49.3713 34.5924C50.3999 33.5598 50.3999 32.0109 49.3713 30.462L44.2285 25.2989C42.6856 24.2663 41.1428 24.2663 40.1142 25.2989C39.0856 26.3315 39.0856 27.8804 40.1142 29.4293L45.7713 35.1087C46.7999 36.1413 48.3428 35.625 49.3713 34.5924Z",
    fill: "url(#paint43_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M49.3713 34.5924C50.3999 33.5598 50.3999 32.0109 49.3713 30.9783L44.2285 25.2989C43.1999 24.2663 41.1428 24.2663 40.1142 25.2989C39.0856 26.3315 39.0856 27.8804 40.1142 28.913L45.7713 34.5924C46.7999 35.625 48.3428 35.625 49.3713 34.5924Z",
    fill: "url(#paint44_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M49.3712 34.0761C50.3998 33.0435 50.3998 31.4946 49.3712 30.462L44.2284 25.2989C43.1998 24.2663 41.6569 24.2663 40.6284 25.2989C39.5998 26.3315 39.5998 27.8804 40.6284 28.913L46.2855 34.5924C46.7998 35.1087 48.3426 35.1087 49.3712 34.0761Z",
    fill: "url(#paint45_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M49.3712 34.0761C50.3998 33.0435 50.3998 31.4946 49.3712 30.462L44.2284 25.2989C43.1998 24.2663 41.6569 24.2663 40.6284 25.2989C39.5998 26.3315 39.5998 27.8804 40.6284 28.913L45.7712 34.0761C46.7998 35.1087 48.3426 35.1087 49.3712 34.0761Z",
    fill: "url(#paint46_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M49.3712 33.5598C50.3998 32.5272 50.3998 30.9783 49.3712 29.9457L44.2284 24.7826C43.1998 23.75 41.657 23.75 40.6284 24.7826C40.1141 25.8152 40.1141 27.3641 40.6284 28.3967L45.7712 33.5598C46.7998 34.5924 48.3427 34.5924 49.3712 33.5598Z",
    fill: "url(#paint47_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.3711 33.5598C50.3997 32.5272 50.3997 30.9783 49.3711 29.9457L44.2282 24.7826C43.714 24.2663 42.1711 24.2663 41.1425 24.7826C40.114 25.8152 40.114 27.3641 41.1425 28.3967L46.2854 33.5598C46.7997 34.5924 48.3425 34.5924 49.3711 33.5598Z",
    fill: "url(#paint48_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M43.1997 54.7283C43.1997 52.663 41.6568 51.1141 40.114 51.1141H30.3425C28.7997 51.1141 27.2568 52.663 27.2568 54.7283C27.2568 56.7935 28.7997 58.3424 30.3425 58.3424H40.114C41.6568 58.3424 43.1997 56.7935 43.1997 54.7283Z",
    fill: "url(#paint49_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M43.1997 54.7283C43.1997 52.663 41.6568 51.1141 40.114 51.1141H30.3425C28.7997 51.1141 27.2568 52.663 27.2568 54.7283C27.2568 56.7935 28.7997 58.3424 30.3425 58.3424H40.114C41.6568 58.3424 43.1997 56.7935 43.1997 54.7283Z",
    fill: "url(#paint50_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M43.1997 54.7283C43.1997 52.663 41.6568 51.1141 40.114 51.1141H30.3425C28.7997 51.1141 27.2568 52.663 27.2568 54.7283C27.2568 56.7935 28.7997 58.3424 30.3425 58.3424H39.5997C41.6568 57.8261 43.1997 56.2772 43.1997 54.7283Z",
    fill: "url(#paint51_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M43.2001 54.212C43.2001 52.1467 41.6572 50.5978 40.1143 50.5978H30.8572C29.3143 50.5978 27.7715 52.1467 27.7715 54.212C27.7715 56.2772 29.3143 57.8261 30.8572 57.8261H40.1143C41.6572 57.8261 43.2001 56.2772 43.2001 54.212Z",
    fill: "url(#paint52_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M42.6858 54.212C42.6858 52.1467 41.1429 51.1141 39.6001 51.1141H30.8572C29.3143 51.1141 27.7715 52.663 27.7715 54.212C27.7715 56.2772 29.3143 57.3098 30.8572 57.3098H40.1143C41.6572 57.3098 42.6858 56.2772 42.6858 54.212Z",
    fill: "url(#paint53_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M42.6858 54.212C42.6858 52.663 41.1429 51.1141 39.6001 51.1141H30.8572C29.3143 51.1141 27.7715 52.663 27.7715 54.212C27.7715 55.7609 29.3143 57.3098 30.8572 57.3098H39.6001C41.6572 57.3098 42.6858 55.7609 42.6858 54.212Z",
    fill: "url(#paint54_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M42.6856 53.6956C42.6856 52.1467 41.1428 50.5978 39.5999 50.5978H31.3714C29.8285 50.5978 28.2856 52.1467 28.2856 53.6956C28.2856 55.2446 29.8285 56.7935 31.3714 56.7935H40.1142C41.6571 56.7935 42.6856 55.7609 42.6856 53.6956Z",
    fill: "url(#paint55_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.6856 53.6956C42.6856 52.1467 41.6571 50.5978 39.5999 50.5978H31.3714C29.8285 50.5978 28.2856 52.1467 28.2856 53.6956C28.2856 55.2446 29.3142 56.7935 31.3714 56.7935H40.1142C41.6571 56.7935 42.6856 55.2446 42.6856 53.6956Z",
    fill: "url(#paint56_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M42.6855 53.6956C42.6855 52.1467 41.6569 50.5978 40.1141 50.5978H31.3712C29.8284 50.5978 28.7998 52.1467 28.7998 53.6956C28.7998 55.2446 29.8284 56.7935 31.3712 56.7935H39.5998C41.6569 56.7935 42.6855 55.2446 42.6855 53.6956Z",
    fill: "url(#paint57_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M42.6854 53.6956C42.6854 51.6304 41.1425 50.5978 40.114 50.5978H31.8854C30.3425 50.5978 29.314 52.1467 29.314 53.6956C29.314 55.2446 30.3425 56.7935 31.8854 56.7935H40.114C41.1425 56.2772 42.6854 55.2446 42.6854 53.6956Z",
    fill: "url(#paint58_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M42.6854 53.1793C42.6854 51.6304 41.1425 50.5978 40.114 50.5978H31.8854C30.3425 50.5978 29.314 51.6304 29.314 53.1793C29.314 54.7283 30.3425 55.7609 31.8854 55.7609H40.114C41.1425 56.2772 42.6854 54.7283 42.6854 53.1793Z",
    fill: "url(#paint59_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M42.6854 53.1793C42.6854 51.6304 41.1425 50.5978 40.114 50.5978H31.8854C30.3425 50.5978 29.314 51.6304 29.314 53.1793C29.314 54.7283 30.3425 55.7609 31.8854 55.7609H39.5997C41.1425 55.7609 42.6854 54.7283 42.6854 53.1793Z",
    fill: "url(#paint60_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M42.1715 53.1793C42.1715 51.6304 41.1429 50.5978 39.6 50.5978H32.4C30.8572 50.5978 29.8286 51.6304 29.8286 53.1793C29.8286 54.7283 30.8572 55.7609 32.4 55.7609H40.1143C41.1429 55.7609 42.1715 54.7283 42.1715 53.1793Z",
    fill: "url(#paint61_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M42.1715 52.663C42.1715 51.6304 41.1429 50.0815 39.6 50.0815H32.4C30.8572 50.0815 29.8286 51.6304 29.8286 52.663C29.8286 54.212 30.8572 55.2446 32.4 55.2446H40.1143C41.1429 55.2446 42.1715 54.212 42.1715 52.663Z",
    fill: "url(#paint62_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M42.1715 52.663C42.1715 51.1141 41.1429 50.0815 39.6 50.0815H32.4C30.8572 50.0815 29.8286 51.1141 29.8286 52.663C29.8286 54.212 30.8572 55.2446 32.4 55.2446H39.6C41.1429 55.2446 42.1715 54.212 42.1715 52.663Z",
    fill: "url(#paint63_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.1715 52.663C42.1715 51.1141 41.1429 50.0815 39.6 50.0815H32.4C30.8572 50.0815 29.8286 51.1141 29.8286 52.663C29.8286 54.212 30.8572 55.2446 32.4 55.2446H39.6C41.1429 54.7283 42.1715 53.6957 42.1715 52.663Z",
    fill: "url(#paint64_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M50.9138 71.7663C49.371 70.2174 47.3138 70.2174 46.2853 71.7663L39.5996 78.4783C38.571 79.5109 38.571 82.0924 39.5996 83.125C41.1424 84.6739 43.1996 84.6739 44.2281 83.125L50.9138 76.413C52.4567 75.3804 52.4567 73.3152 50.9138 71.7663Z",
    fill: "url(#paint65_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M50.9138 71.7663C49.371 70.2174 47.3138 70.2174 46.2853 71.7663L39.5996 78.4783C38.571 79.5109 38.571 82.0924 39.5996 83.125C41.1424 84.6739 43.1996 84.6739 44.2281 83.125L50.9138 76.413C52.4567 75.3804 51.9424 73.3152 50.9138 71.7663Z",
    fill: "url(#paint66_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M50.9138 71.7663C49.371 70.2174 47.3138 70.2174 46.2853 71.7663L39.5996 78.4783C38.571 79.5109 38.571 81.5761 39.5996 83.125C41.1424 84.6739 43.1996 84.6739 44.2281 83.125L50.9138 76.413C52.4567 75.3804 51.9424 73.3152 50.9138 71.7663Z",
    fill: "url(#paint67_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M50.9138 71.7663C49.371 70.2174 47.3138 70.2174 46.2853 71.7663L39.5996 78.4783C38.571 79.5109 38.571 81.5761 39.5996 83.125C41.1424 84.6739 43.1996 84.6739 44.2281 83.125L50.9138 76.413C51.9424 75.3804 51.9424 73.3152 50.9138 71.7663Z",
    fill: "url(#paint68_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M50.9142 71.7663C49.8856 70.7337 47.8285 70.2174 46.2856 71.7663L40.1142 77.962C39.0856 78.9946 39.0856 81.0598 40.1142 82.6087C41.1428 83.6413 43.1999 84.1576 44.7428 82.6087L50.9142 76.413C51.9428 74.8641 51.9428 72.7989 50.9142 71.7663Z",
    fill: "url(#paint69_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M50.9141 71.7663C49.8855 70.7337 47.8284 70.2174 46.7998 71.7663L40.6284 77.962C39.5998 78.9946 39.5998 81.0598 40.6284 82.0924C41.6569 83.125 43.7141 83.6413 44.7426 82.0924L50.9141 75.8967C51.9426 74.8641 51.9426 72.7989 50.9141 71.7663Z",
    fill: "url(#paint70_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M50.9142 71.7663C49.8856 70.7337 47.8285 70.7337 46.7999 71.7663L40.1142 77.4457C39.0856 78.4783 39.0856 80.5435 40.1142 81.5761C41.1428 82.6087 43.1999 82.6087 44.2285 81.5761L50.3999 75.3804C51.9428 74.8641 51.9428 72.7989 50.9142 71.7663Z",
    fill: "url(#paint71_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.9141 71.7663C49.8855 70.7337 47.8284 70.7337 46.7998 71.7663L40.6284 77.4457C39.5998 78.4783 39.5998 80.5435 40.6284 81.5761C41.6569 82.6087 43.7141 82.6087 44.7426 81.5761L50.9141 75.3804C51.9426 74.8641 51.9426 72.7989 50.9141 71.7663Z",
    fill: "url(#paint72_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M50.9141 71.7663C49.8855 70.7337 47.8284 70.7337 46.7998 71.7663L40.6284 77.4457C39.5998 78.4783 39.5998 80.5435 40.6284 81.5761C41.6569 82.6087 43.7141 82.6087 44.7426 81.5761L50.9141 75.3804C51.9426 74.3478 51.9426 72.7989 50.9141 71.7663Z",
    fill: "url(#paint73_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M50.3997 71.25C49.3711 70.2174 47.3139 70.2174 46.2854 71.25L41.1425 77.4457C40.114 78.4783 40.114 80.5435 41.1425 81.5761C42.1711 82.6087 44.2282 82.6087 45.2568 81.5761L50.9139 75.8967C51.9425 74.3478 51.9425 72.7989 50.3997 71.25Z",
    fill: "url(#paint74_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M50.3997 71.25C49.3711 70.2174 47.8282 70.2174 46.2854 71.25L41.1425 76.9294C40.114 77.962 40.114 79.5109 41.1425 81.0598C42.1711 82.0924 43.714 82.0924 45.2568 81.0598L50.9139 75.3804C51.9425 74.3478 51.9425 72.2826 50.3997 71.25Z",
    fill: "url(#paint75_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M50.3997 71.25C49.3711 70.2174 47.8282 70.2174 46.7997 71.25L41.1425 76.9293C40.114 77.962 40.114 79.5109 41.1425 80.5435C42.1711 81.5761 43.714 81.5761 44.7425 80.5435L50.3997 74.8641C51.9425 74.3478 51.4282 72.2826 50.3997 71.25Z",
    fill: "url(#paint76_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M50.3997 71.25C49.3711 70.2174 47.8282 70.2174 46.7997 71.25L41.1425 76.9293C40.114 77.962 40.114 79.5109 41.1425 80.5435C42.1711 81.5761 43.7139 81.5761 44.7425 80.5435L50.3997 74.8641C51.4282 73.8315 51.4282 72.2826 50.3997 71.25Z",
    fill: "url(#paint77_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M50.4 71.25C49.3715 70.2174 47.8286 70.2174 46.8 71.25L41.6572 76.413C40.6286 77.4457 40.6286 78.9946 41.6572 80.0272C42.6857 81.0598 44.2286 81.0598 45.2572 80.0272L50.4 74.8641C51.4286 73.8315 51.4286 72.2826 50.4 71.25Z",
    fill: "url(#paint78_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M50.3996 71.25C49.371 70.2174 47.8281 70.2174 46.7996 71.25L41.6567 76.413C41.1424 77.4457 41.1424 78.9946 41.6567 80.0272C42.6853 81.0598 44.2281 81.0598 45.2567 80.0272L50.3996 74.8641C51.4281 73.8315 51.4281 72.2826 50.3996 71.25Z",
    fill: "url(#paint79_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.4 71.25C49.3714 70.2174 47.8286 70.2174 46.8 71.25L41.6571 76.413C41.1429 77.4457 41.1429 78.9946 42.1714 79.5109C43.2 80.5435 44.7429 80.5435 45.7714 79.5109L50.9143 74.3478C51.4286 73.8315 51.4286 72.2826 50.4 71.25Z",
    fill: "url(#paint80_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M68.3998 78.4783C66.3427 78.4783 64.7998 80.0272 64.7998 81.5761V91.3859C64.7998 92.9348 66.3427 94.4837 68.3998 94.4837C70.4569 94.4837 71.9998 92.9348 71.9998 91.3859V81.5761C71.9998 80.0272 70.4569 78.4783 68.3998 78.4783Z",
    fill: "url(#paint81_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M68.3998 78.4783C66.3427 78.4783 64.7998 80.0272 64.7998 81.5761V91.3859C64.7998 92.9348 66.3427 94.4837 68.3998 94.4837C70.4569 94.4837 71.9998 92.9348 71.9998 91.3859V81.5761C71.9998 80.0272 70.4569 78.4783 68.3998 78.4783Z",
    fill: "url(#paint82_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M68.3998 78.4783C66.3427 78.4783 64.7998 80.0272 64.7998 81.5761V90.8696C64.7998 92.4185 66.3427 93.9674 68.3998 93.9674C70.4569 93.9674 71.9998 92.4185 71.9998 90.8696V81.5761C71.9998 80.0272 70.4569 78.4783 68.3998 78.4783Z",
    fill: "url(#paint83_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M68.3998 78.4783C66.3427 78.4783 64.7998 80.0272 64.7998 81.5761V90.8696C64.7998 92.4185 66.3427 93.9674 68.3998 93.9674C70.4569 93.9674 71.9998 92.4185 71.9998 90.8696V81.5761C71.9998 80.0272 70.4569 78.4783 68.3998 78.4783Z",
    fill: "url(#paint84_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M68.3997 78.4783C66.3425 78.4783 65.314 80.0272 65.314 81.5761V90.8696C65.314 92.4185 66.8568 93.9674 68.3997 93.9674C70.4568 93.9674 71.4854 92.4185 71.4854 90.8696V81.5761C71.9997 80.0272 70.4568 78.4783 68.3997 78.4783Z",
    fill: "url(#paint85_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M68.9143 78.4783C67.3715 78.4783 65.8286 80.0272 65.8286 81.5761V90.3533C65.8286 91.9022 67.3715 93.4511 68.9143 93.4511C70.4572 93.4511 72 91.9022 72 90.3533V81.5761C72 80.0272 70.4572 78.4783 68.9143 78.4783Z",
    fill: "url(#paint86_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M68.9143 78.4783C67.3715 78.4783 65.8286 80.0272 65.8286 81.5761V90.3533C65.8286 91.9022 67.3715 93.4511 68.9143 93.4511C70.4572 93.4511 72 91.9022 72 90.3533V81.5761C72 80.0272 70.4572 78.4783 68.9143 78.4783Z",
    fill: "url(#paint87_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.9143 78.4783C67.3715 78.4783 65.8286 79.5109 65.8286 81.5761V90.3533C65.8286 91.9022 67.3715 93.4511 68.9143 93.4511C70.4572 93.4511 72 92.4185 72 90.3533V81.5761C72 80.0272 70.4572 78.4783 68.9143 78.4783Z",
    fill: "url(#paint88_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M68.9143 78.4783C67.3715 78.4783 65.8286 79.5109 65.8286 81.0598V89.3207C65.8286 90.8696 67.3715 91.9022 68.9143 91.9022C70.4572 91.9022 72 90.8696 72 89.3207V81.0598C72 80.0272 70.4572 78.4783 68.9143 78.4783Z",
    fill: "url(#paint89_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M68.9143 78.4783C67.3715 78.4783 65.8286 79.5109 65.8286 81.0598V89.3207C65.8286 90.8696 67.3715 91.9022 68.9143 91.9022C70.4572 91.9022 72 90.8696 72 89.3207V81.0598C72 79.5109 70.4572 78.4783 68.9143 78.4783Z",
    fill: "url(#paint90_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M68.9142 78.4783C67.3713 78.4783 66.3428 79.5109 66.3428 81.0598V89.3207C66.3428 90.8696 67.3713 91.9022 68.9142 91.9022C70.4571 91.9022 71.4856 90.8696 71.4856 89.3207V81.0598C71.9999 79.5109 70.4571 78.4783 68.9142 78.4783Z",
    fill: "url(#paint91_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M69.4284 78.4783C67.8855 78.4783 66.8569 79.5109 66.8569 81.0598V88.8044C66.8569 90.3533 67.8855 91.3859 69.4284 91.3859C70.9712 91.3859 71.9998 90.3533 71.9998 88.8044V81.0598C71.9998 79.5109 70.4569 78.4783 69.4284 78.4783Z",
    fill: "url(#paint92_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M69.4284 78.4783C67.8855 78.4783 66.8569 79.5109 66.8569 81.0598V88.8044C66.8569 90.3533 67.8855 91.3859 69.4284 91.3859C70.9712 91.3859 71.9998 90.3533 71.9998 88.8044V81.0598C71.9998 79.5109 70.9712 78.4783 69.4284 78.4783Z",
    fill: "url(#paint93_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M69.4284 78.4783C67.8855 78.4783 66.8569 79.5109 66.8569 81.0598V88.8044C66.8569 90.3533 67.8855 91.3859 69.4284 91.3859C70.9712 91.3859 71.9998 90.3533 71.9998 88.8044V81.0598C71.9998 79.5109 70.9712 78.4783 69.4284 78.4783Z",
    fill: "url(#paint94_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M69.4284 78.4783C67.8855 78.4783 66.8569 79.5109 66.8569 81.0598V88.288C66.8569 89.837 67.8855 90.8696 69.4284 90.8696C70.9712 90.8696 71.9998 89.837 71.9998 88.288V81.0598C71.9998 79.5109 70.9712 78.4783 69.4284 78.4783Z",
    fill: "url(#paint95_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.4284 78.4783C67.8855 78.4783 66.8569 79.5109 66.8569 81.0598V88.288C66.8569 89.837 67.8855 90.8696 69.4284 90.8696C70.9712 90.8696 71.9998 89.837 71.9998 88.288V81.0598C71.9998 79.5109 70.9712 78.4783 69.4284 78.4783Z",
    fill: "url(#paint96_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M85.3715 70.7337C83.8286 72.2826 83.8286 74.3478 85.3715 75.3804L92.0572 82.0924C93.0858 83.125 95.6572 83.125 96.6858 82.0924C98.2286 80.5435 98.2286 78.4783 96.6858 77.4457L90.0001 70.7337C88.9715 69.1848 86.9144 69.7011 85.3715 70.7337Z",
    fill: "url(#paint97_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M85.3715 70.7337C83.8286 72.2826 83.8286 74.3478 85.3715 75.3804L92.0572 82.0924C93.0858 83.125 95.6572 83.125 96.6858 82.0924C98.2286 80.5435 98.2286 78.4783 96.6858 77.4457L90.0001 70.7337C88.9715 69.1848 86.9144 69.7011 85.3715 70.7337Z",
    fill: "url(#paint98_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M85.8857 70.7337C84.3428 72.2826 84.3428 74.3478 85.8857 75.3804L92.5714 82.0924C93.5999 83.125 95.6571 83.125 97.1999 82.0924C98.7428 80.5435 98.7428 78.4783 97.1999 77.4457L90.5142 70.7337C88.9714 69.1848 86.9142 69.1848 85.8857 70.7337Z",
    fill: "url(#paint99_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M85.8857 70.7337C84.3428 72.2826 84.3428 74.3478 85.8857 75.3804L92.5714 82.0924C93.5999 83.125 95.6571 83.125 97.1999 82.0924C98.7428 80.5435 98.7428 78.4783 97.1999 77.4457L90.5142 70.7337C89.4857 69.1848 87.4285 69.1848 85.8857 70.7337Z",
    fill: "url(#paint100_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M85.8854 70.7337C84.8568 71.7663 84.3425 73.8315 85.8854 75.3804L92.0568 81.5761C93.0854 82.6087 95.1425 82.6087 96.6854 81.5761C97.7139 80.5435 98.2282 78.4783 96.6854 76.9293L90.5139 70.7337C89.4854 69.1848 87.4282 69.1848 85.8854 70.7337Z",
    fill: "url(#paint101_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M86.4 70.7337C85.3714 71.7663 84.8572 73.8315 86.4 74.8641L92.5714 81.0598C93.6 82.0924 95.6572 82.0924 96.6857 81.0598C97.7143 80.0272 98.2286 77.962 96.6857 76.9293L90.5143 70.7337C89.4857 69.1848 87.4286 69.1848 86.4 70.7337Z",
    fill: "url(#paint102_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M86.3998 70.7337C85.3713 71.7663 85.3713 73.8315 86.3998 74.8641L92.5713 81.0598C93.5998 82.0924 95.657 82.0924 96.6856 81.0598C97.7141 80.0272 97.7141 77.962 96.6856 76.9293L90.5141 70.7337C89.4856 69.1848 87.4284 69.1848 86.3998 70.7337Z",
    fill: "url(#paint103_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.3998 70.7337C85.3713 71.7663 85.3713 73.8315 86.3998 74.8641L92.5713 81.0598C93.5998 82.0924 95.657 82.0924 96.6856 81.0598C97.7141 80.0272 97.7141 77.962 96.6856 76.9293L90.5141 70.7337C89.4856 69.1848 87.9427 69.1848 86.3998 70.7337Z",
    fill: "url(#paint104_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M86.914 70.7337C85.8854 71.7663 85.8854 73.8315 86.914 74.8641L93.0854 81.0598C94.114 82.0924 96.1711 82.0924 97.1997 81.0598C98.2283 80.0272 98.2283 77.962 97.1997 76.9293L91.0283 70.7337C89.9997 69.1848 87.9426 69.1848 86.914 70.7337Z",
    fill: "url(#paint105_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M86.914 70.2174C85.8854 71.25 85.8854 73.3152 86.914 74.3478L92.5711 80.0272C93.5997 81.0598 95.6569 81.0598 96.6854 80.0272C97.714 78.9946 97.714 76.9294 96.6854 75.8967L91.0283 70.2174C89.9997 69.1848 87.9426 69.1848 86.914 70.2174Z",
    fill: "url(#paint106_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M86.914 70.2174C85.8854 71.25 85.8854 72.7989 86.914 74.3478L92.5711 80.0272C93.5997 81.0598 95.1426 81.0598 96.6854 80.0272C97.714 78.9946 97.714 77.4457 96.6854 75.8967L91.0283 70.2174C89.9997 69.1848 88.4569 69.1848 86.914 70.2174Z",
    fill: "url(#paint107_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M87.4287 70.2174C86.4001 71.25 86.4001 72.7989 87.4287 73.8315L93.0858 79.5109C94.1144 80.5435 95.6572 80.5435 96.6858 79.5109C97.7144 78.4783 97.7144 76.9293 96.6858 75.8967L91.0287 70.2174C90.0001 69.1848 88.4572 69.1848 87.4287 70.2174Z",
    fill: "url(#paint108_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M87.4287 70.2174C86.4001 71.25 86.4001 72.7989 87.4287 73.8315L93.0858 79.5109C94.1144 80.5435 95.6572 80.5435 96.6858 79.5109C97.7144 78.4783 97.7144 76.9293 96.6858 75.8967L91.0287 70.2174C90.0001 69.1848 88.4572 69.1848 87.4287 70.2174Z",
    fill: "url(#paint109_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M87.9428 70.2174C86.9142 71.25 86.9142 72.7989 87.9428 73.8315L93.0857 78.9946C94.1142 80.0272 95.6571 80.0272 96.6857 78.9946C97.7142 77.962 97.7142 76.413 96.6857 75.3804L91.5428 70.2174C90.5142 69.1848 88.4571 69.1848 87.9428 70.2174Z",
    fill: "url(#paint110_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M87.9428 70.2174C86.9142 71.25 86.9142 72.7989 87.9428 73.8315L93.0857 78.9946C94.1142 80.0272 95.6571 80.0272 96.6857 78.9946C97.7142 77.962 97.7142 76.413 96.6857 75.3804L91.5428 70.2174C90.5142 69.1848 88.9714 69.1848 87.9428 70.2174Z",
    fill: "url(#paint111_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M87.9428 70.2174C86.9142 71.25 86.9142 72.7989 87.9428 73.8315L93.0857 78.9946C94.1142 80.0272 95.6571 80.0272 96.6857 78.9946C97.7142 77.962 97.7142 76.413 96.6857 75.3804L91.5428 70.2174C90.5142 69.1848 88.9714 69.1848 87.9428 70.2174Z",
    fill: "url(#paint112_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M92.0566 53.1794C92.0566 55.2446 93.5995 56.7935 95.1424 56.7935H104.914C106.457 56.7935 107.999 55.2446 107.999 53.1794C107.999 51.1141 106.457 49.5652 104.914 49.5652H95.1424C93.5995 49.5652 92.0566 51.1141 92.0566 53.1794Z",
    fill: "url(#paint113_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M92.0566 53.1794C92.0566 55.2446 93.5995 56.7935 95.1424 56.7935H104.914C106.457 56.7935 107.999 55.2446 107.999 53.1794C107.999 51.1141 106.457 49.5652 104.914 49.5652H95.1424C93.5995 49.5652 92.0566 51.1141 92.0566 53.1794Z",
    fill: "url(#paint114_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M92.5713 53.1794C92.5713 55.2446 94.1141 56.7935 95.657 56.7935H104.914C106.457 56.7935 108 55.2446 108 53.1794C108 51.1141 106.457 49.5652 104.914 49.5652H95.657C93.5999 49.5652 92.5713 51.1141 92.5713 53.1794Z",
    fill: "url(#paint115_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M92.5713 52.663C92.5713 54.7283 94.1141 56.2772 95.657 56.2772H104.914C106.457 56.2772 108 54.7283 108 52.663C108 50.5978 106.457 49.0489 104.914 49.0489H95.657C94.1141 49.5652 92.5713 51.1141 92.5713 52.663Z",
    fill: "url(#paint116_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M93.0854 52.663C93.0854 54.7283 94.6283 55.7609 96.1712 55.7609H105.428C106.971 55.7609 108.514 54.212 108.514 52.663C108.514 50.5978 106.971 49.5652 105.428 49.5652H96.1712C94.114 49.5652 93.0854 51.1141 93.0854 52.663Z",
    fill: "url(#paint117_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M93.0854 52.663C93.0854 54.212 94.6283 55.7609 96.1712 55.7609H104.914C106.457 55.7609 108 54.212 108 52.663C108 51.1141 106.457 49.5652 104.914 49.5652H96.1712C94.6283 49.5652 93.0854 50.5978 93.0854 52.663Z",
    fill: "url(#paint118_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M93.0854 52.663C93.0854 54.212 94.6283 55.7609 96.1712 55.7609H104.914C106.457 55.7609 108 54.212 108 52.663C108 51.1141 106.457 49.5652 104.914 49.5652H96.1712C94.6283 49.0489 93.0854 50.5978 93.0854 52.663Z",
    fill: "url(#paint119_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.5996 52.1467C93.5996 53.6957 94.6282 55.2446 96.6853 55.2446H105.428C106.971 55.2446 108.514 53.6957 108.514 52.1467C108.514 50.5978 107.485 49.0489 105.428 49.0489H96.6853C94.6282 49.0489 93.5996 50.5978 93.5996 52.1467Z",
    fill: "url(#paint120_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M93.5996 52.1467C93.5996 53.6957 94.6282 55.2446 96.171 55.2446H104.4C105.942 55.2446 106.971 53.6957 106.971 52.1467C106.971 50.5978 105.942 49.0489 104.4 49.0489H96.171C95.1425 49.0489 93.5996 50.5978 93.5996 52.1467Z",
    fill: "url(#paint121_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M94.1138 52.1467C94.1138 53.6957 95.1423 55.2446 96.6852 55.2446H104.914C106.457 55.2446 107.485 53.6957 107.485 52.1467C107.485 50.5978 106.457 49.0489 104.914 49.0489H96.6852C95.1423 49.0489 94.1138 50.5978 94.1138 52.1467Z",
    fill: "url(#paint122_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M94.1138 51.6304C94.1138 53.1793 95.1423 54.212 96.6852 54.212H104.914C106.457 54.212 107.485 53.1793 107.485 51.6304C107.485 50.0815 106.457 49.0489 104.914 49.0489H96.6852C95.1423 49.0489 94.1138 50.0815 94.1138 51.6304Z",
    fill: "url(#paint123_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M94.6284 51.6304C94.6284 53.1793 95.657 54.212 97.1998 54.212H104.914C106.457 54.212 107.486 53.1793 107.486 51.6304C107.486 50.0815 106.457 49.0489 104.914 49.0489H97.1998C95.657 49.0489 94.6284 50.0815 94.6284 51.6304Z",
    fill: "url(#paint124_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M94.6284 51.6304C94.6284 53.1793 95.657 54.212 97.1998 54.212H104.914C106.457 54.212 107.486 53.1793 107.486 51.6304C107.486 50.0815 106.457 49.0489 104.914 49.0489H97.1998C95.657 49.0489 94.6284 50.0815 94.6284 51.6304Z",
    fill: "url(#paint125_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M94.6284 51.1141C94.6284 52.663 95.657 53.6957 97.1998 53.6957H104.914C106.457 53.6957 107.486 52.663 107.486 51.1141C107.486 49.5652 106.457 48.5326 104.914 48.5326H97.1998C96.1713 49.0489 94.6284 50.0815 94.6284 51.1141Z",
    fill: "url(#paint126_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M95.1426 51.1141C95.1426 52.663 96.1711 53.6957 97.714 53.6957H104.914C106.457 53.6957 107.485 52.663 107.485 51.1141C107.485 49.5652 106.457 48.5326 104.914 48.5326H97.714C96.1711 48.5326 95.1426 50.0815 95.1426 51.1141Z",
    fill: "url(#paint127_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.1426 51.1141C95.1426 52.663 96.1711 53.6957 97.714 53.6957H104.914C106.457 53.6957 107.485 52.663 107.485 51.1141C107.485 49.5652 106.457 48.5326 104.914 48.5326H97.714C96.1711 48.5326 95.1426 49.5652 95.1426 51.1141Z",
    fill: "url(#paint128_linear_57_115)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0625,
    d: "M84.3427 36.1413C85.8855 37.6902 87.9427 37.6902 88.9713 36.1413L95.657 29.4293C96.6856 28.3967 96.6856 25.8152 95.657 24.7826C94.1141 23.2337 92.057 23.2337 91.0284 24.7826L84.3427 31.4946C82.7998 32.5272 82.7998 34.5924 84.3427 36.1413Z",
    fill: "url(#paint129_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M84.3424 36.1413C85.8853 37.6902 87.9424 37.6902 88.971 36.1413L95.6567 29.4293C96.6853 28.3967 96.6853 25.8152 95.6567 24.7826C94.1138 23.2337 92.0567 23.2337 91.0281 24.7826L84.3424 30.9783C82.7995 32.5272 83.3138 34.5924 84.3424 36.1413Z",
    fill: "url(#paint130_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1875,
    d: "M84.8566 35.625C86.3995 37.1739 88.4566 37.1739 89.4852 35.625L96.1709 28.913C97.1995 27.8804 97.1995 25.8152 96.1709 24.2663C94.6281 22.7174 92.5709 22.7174 91.5423 24.2663L84.3423 30.9783C83.3138 32.0109 83.3138 34.5924 84.8566 35.625Z",
    fill: "url(#paint131_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M84.8568 35.625C86.3997 37.1739 88.4568 37.1739 89.4854 35.625L96.1711 28.913C97.1997 27.8804 97.1997 25.8152 96.1711 24.2663C94.6283 22.7174 92.5711 22.7174 91.5426 24.2663L84.8568 30.9783C83.314 32.0109 83.314 34.0761 84.8568 35.625Z",
    fill: "url(#paint132_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3125,
    d: "M84.8569 35.1087C85.8855 36.1413 87.9426 36.6576 89.4854 35.1087L95.6569 28.913C96.6855 27.8804 96.6855 25.8152 95.6569 24.2663C94.6283 23.2337 92.5712 22.7174 91.0283 24.2663L84.8569 30.9783C83.8283 32.0109 83.8283 34.0761 84.8569 35.1087Z",
    fill: "url(#paint133_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M85.371 35.1087C86.3996 36.1413 88.4567 36.6576 89.4853 35.1087L95.6567 28.913C96.6853 27.8804 96.6853 25.8152 95.6567 24.7826C94.6282 23.75 92.571 23.2337 91.5424 24.7826L85.371 30.9783C83.8282 31.4946 83.8282 33.5598 85.371 35.1087Z",
    fill: "url(#paint134_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4375,
    d: "M85.371 34.5924C86.3996 35.625 88.4567 35.625 89.4853 34.5924L95.6568 28.3967C96.6853 27.3641 96.6853 25.2989 95.6568 24.2663C94.6282 23.2337 92.571 22.7174 91.5425 24.2663L85.371 30.462C84.3425 31.4946 84.3425 33.5598 85.371 34.5924Z",
    fill: "url(#paint135_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.371 34.5924C86.3996 35.625 88.4567 35.625 89.4853 34.5924L95.6568 28.3967C96.6853 27.3641 96.6853 25.2989 95.6568 24.2663C94.6282 23.2337 92.571 23.2337 91.5425 24.2663L85.371 30.462C84.3425 31.4946 84.3425 33.0435 85.371 34.5924Z",
    fill: "url(#paint136_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5625,
    d: "M85.8852 34.0761C86.9137 35.1087 88.9709 35.1087 89.9994 34.0761L96.1709 27.8804C97.1994 26.8478 97.1994 24.7826 96.1709 23.75C95.1423 22.7174 93.0852 22.7174 92.0566 23.75L85.8852 29.9457C84.3423 30.9783 84.3423 33.0435 85.8852 34.0761Z",
    fill: "url(#paint137_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M85.8852 34.0761C86.9138 35.1087 88.9709 35.1087 89.9995 34.0761L95.6566 28.3967C96.6852 27.3641 96.6852 25.2989 95.6566 24.2663C94.6281 23.2337 92.5709 23.2337 91.5423 24.2663L85.8852 29.9457C84.8566 30.9783 84.8566 33.0435 85.8852 34.0761Z",
    fill: "url(#paint138_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6875,
    d: "M85.8852 33.5598C86.9138 34.5924 88.4566 34.5924 89.9995 33.5598L95.6566 27.8804C96.6852 26.8478 96.6852 25.2989 95.6566 23.75C94.6281 22.7174 93.0852 22.7174 91.5423 23.75L85.8852 29.4293C84.8566 30.9783 84.8566 32.5272 85.8852 33.5598Z",
    fill: "url(#paint139_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M86.3998 33.5598C87.4284 34.5924 88.9713 34.5924 89.9999 33.5598L95.657 27.8804C96.6856 26.8478 96.6856 25.2989 95.657 24.2663C94.6284 23.2337 93.0856 23.2337 92.057 24.2663L86.3998 29.9457C85.3713 30.462 85.3713 32.5272 86.3998 33.5598Z",
    fill: "url(#paint140_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8125,
    d: "M86.3998 33.0435C87.4284 34.0761 88.9713 34.0761 89.9999 33.0435L95.657 27.3641C96.6856 26.3315 96.6856 24.7826 95.657 23.75C94.6284 22.7174 93.0856 22.7174 92.057 23.75L86.3998 29.4293C85.3713 30.462 85.3713 32.0109 86.3998 33.0435Z",
    fill: "url(#paint141_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M86.3994 33.0435C87.428 34.0761 88.9708 34.0761 89.9994 33.0435L95.1422 27.8804C96.1708 26.8478 96.1708 25.2989 95.1422 24.2663C94.1137 23.2337 92.5708 23.2337 91.5422 24.2663L86.3994 29.4293C85.8851 30.462 85.8851 32.0109 86.3994 33.0435Z",
    fill: "url(#paint142_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9375,
    d: "M86.914 32.5272C87.9426 33.5598 89.4854 33.5598 90.514 32.5272L95.6569 27.3641C96.6854 26.3315 96.6854 24.7826 95.6569 23.75C94.6283 22.7174 93.0854 22.7174 92.0569 23.75L86.914 28.913C85.8854 29.9457 85.8854 31.4946 86.914 32.5272Z",
    fill: "url(#paint143_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.914 32.5272C87.9426 33.5598 89.4854 33.5598 90.514 32.5272L95.6569 27.3641C96.6854 26.3315 96.6854 24.7826 95.6569 23.75C94.6283 22.7174 93.0854 22.7174 92.0569 23.75L86.914 28.913C85.8854 29.9457 85.8854 31.4946 86.914 32.5272Z",
    fill: "url(#paint144_linear_57_115)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67.8857 29.9457C56.0571 29.9457 46.2856 39.7554 46.2856 51.6304C46.2856 63.5054 56.0571 73.3152 67.8857 73.3152C79.7142 73.3152 89.4857 63.5054 89.4857 51.6304C89.4857 39.7554 79.7142 29.9457 67.8857 29.9457Z",
    fill: "url(#paint145_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8859 25.2989C69.4287 25.2989 70.4573 24.2663 70.4573 22.7174V15.4891C70.4573 13.9402 69.4287 12.9076 67.8859 12.9076C66.343 12.9076 65.3145 13.9402 65.3145 15.4891V22.7174C65.8287 24.2663 66.8573 25.2989 67.8859 25.2989Z",
    fill: "url(#paint146_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3716 33.5598C50.4002 32.5272 50.4002 30.9783 49.3716 29.9457L44.2287 24.7826C43.7144 24.2663 42.1716 24.2663 41.143 24.7826C40.1144 25.8152 40.1144 27.3641 41.143 28.3967L46.2859 33.5598C46.8002 34.5924 48.343 34.5924 49.3716 33.5598Z",
    fill: "url(#paint147_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1715 52.663C42.1715 51.1141 41.1429 50.0815 39.6 50.0815H32.4C30.8572 50.0815 29.8286 51.1141 29.8286 52.663C29.8286 54.212 30.8572 55.2446 32.4 55.2446H39.6C41.1429 54.7283 42.1715 53.6957 42.1715 52.663Z",
    fill: "url(#paint148_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 71.25C49.3714 70.2174 47.8286 70.2174 46.8 71.25L41.6571 76.413C41.1429 77.4457 41.1429 78.9946 42.1714 79.5109C43.2 80.5435 44.7429 80.5435 45.7714 79.5109L50.9143 74.3478C51.4286 73.8315 51.4286 72.2826 50.4 71.25Z",
    fill: "url(#paint149_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4288 78.4783C67.886 78.4783 66.8574 79.5109 66.8574 81.0598V88.288C66.8574 89.837 67.886 90.8696 69.4288 90.8696C70.9717 90.8696 72.0003 89.837 72.0003 88.288V81.0598C72.0003 79.5109 70.9717 78.4783 69.4288 78.4783Z",
    fill: "url(#paint150_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9428 70.2174C86.9142 71.25 86.9142 72.7989 87.9428 73.8315L93.0857 78.9946C94.1142 80.0272 95.6571 80.0272 96.6857 78.9946C97.7142 77.962 97.7142 76.413 96.6857 75.3804L91.5428 70.2174C90.5142 69.1848 88.9714 69.1848 87.9428 70.2174Z",
    fill: "url(#paint151_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1431 51.1141C95.1431 52.663 96.1716 53.6957 97.7145 53.6957H104.914C106.457 53.6957 107.486 52.663 107.486 51.1141C107.486 49.5652 106.457 48.5326 104.914 48.5326H97.7145C96.1716 48.5326 95.1431 49.5652 95.1431 51.1141Z",
    fill: "url(#paint152_linear_57_115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9145 32.5272C87.9431 33.5598 89.4859 33.5598 90.5145 32.5272L95.6574 27.3641C96.6859 26.3315 96.6859 24.7826 95.6574 23.75C94.6288 22.7174 93.0859 22.7174 92.0574 23.75L86.9145 28.913C85.8859 29.9457 85.8859 31.4946 86.9145 32.5272Z",
    fill: "url(#paint153_linear_57_115)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_115",
    x1: 0,
    y1: 22.3766,
    x2: 70.1594,
    y2: 22.3766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#729FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_115",
    x1: 42.5265,
    y1: 14.3336,
    x2: 91.2984,
    y2: 93.1136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_115",
    x1: 42.8726,
    y1: 14.6161,
    x2: 91.1107,
    y2: 92.5341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_115",
    x1: 43.2186,
    y1: 14.8985,
    x2: 90.9235,
    y2: 91.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_115",
    x1: 43.5647,
    y1: 15.1809,
    x2: 90.7353,
    y2: 91.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_57_115",
    x1: 43.9101,
    y1: 15.4633,
    x2: 90.5474,
    y2: 90.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_57_115",
    x1: 44.2561,
    y1: 15.7457,
    x2: 90.3596,
    y2: 90.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_57_115",
    x1: 44.6022,
    y1: 16.0281,
    x2: 90.172,
    y2: 89.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_57_115",
    x1: 44.9481,
    y1: 16.3106,
    x2: 89.9847,
    y2: 89.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_57_115",
    x1: 45.2942,
    y1: 16.5935,
    x2: 89.7971,
    y2: 88.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_57_115",
    x1: 45.6397,
    y1: 16.8759,
    x2: 89.6093,
    y2: 87.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_57_115",
    x1: 45.9858,
    y1: 17.1583,
    x2: 89.4217,
    y2: 87.3192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_57_115",
    x1: 46.3312,
    y1: 17.4408,
    x2: 89.2333,
    y2: 86.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_57_115",
    x1: 46.6773,
    y1: 17.7232,
    x2: 89.0456,
    y2: 86.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_57_115",
    x1: 47.0233,
    y1: 18.0056,
    x2: 88.8583,
    y2: 85.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_57_115",
    x1: 47.3692,
    y1: 18.288,
    x2: 88.6705,
    y2: 85.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_57_115",
    x1: 47.7154,
    y1: 18.5704,
    x2: 88.4829,
    y2: 84.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_57_115",
    x1: 58.7862,
    y1: 8.33935,
    x2: 114.679,
    y2: 98.6229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_57_115",
    x1: 59.0109,
    y1: 8.42557,
    x2: 113.895,
    y2: 97.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_57_115",
    x1: 59.2362,
    y1: 8.51128,
    x2: 113.111,
    y2: 95.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_57_115",
    x1: 59.4614,
    y1: 8.59698,
    x2: 112.327,
    y2: 93.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_57_115",
    x1: 59.686,
    y1: 8.68269,
    x2: 111.543,
    y2: 92.4466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_57_115",
    x1: 59.9112,
    y1: 8.7684,
    x2: 110.76,
    y2: 90.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_57_115",
    x1: 60.1364,
    y1: 8.8541,
    x2: 109.976,
    y2: 89.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_57_115",
    x1: 60.3616,
    y1: 8.93981,
    x2: 109.193,
    y2: 87.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_57_115",
    x1: 60.5864,
    y1: 9.02551,
    x2: 108.41,
    y2: 86.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_57_115",
    x1: 60.8116,
    y1: 9.11122,
    x2: 107.627,
    y2: 84.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_57_115",
    x1: 61.0363,
    y1: 9.19641,
    x2: 106.844,
    y2: 83.1887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_57_115",
    x1: 61.2607,
    y1: 9.28212,
    x2: 106.061,
    y2: 81.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_57_115",
    x1: 61.4861,
    y1: 9.36731,
    x2: 105.279,
    y2: 80.1051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_57_115",
    x1: 61.7109,
    y1: 9.45302,
    x2: 104.497,
    y2: 78.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_57_115",
    x1: 61.9356,
    y1: 9.53821,
    x2: 103.715,
    y2: 77.0237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_57_115",
    x1: 62.1604,
    y1: 9.6234,
    x2: 102.934,
    y2: 75.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_57_115",
    x1: 29.1457,
    y1: 27.966,
    x2: 132.218,
    y2: 52.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_57_115",
    x1: 29.4955,
    y1: 27.8805,
    x2: 130.705,
    y2: 51.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_57_115",
    x1: 29.8446,
    y1: 27.7937,
    x2: 129.193,
    y2: 51.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_57_115",
    x1: 30.1941,
    y1: 27.7075,
    x2: 127.681,
    y2: 50.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_57_115",
    x1: 30.5426,
    y1: 27.621,
    x2: 126.168,
    y2: 50.2067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_57_115",
    x1: 30.8912,
    y1: 27.5345,
    x2: 124.657,
    y2: 49.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_57_115",
    x1: 31.2413,
    y1: 27.449,
    x2: 123.145,
    y2: 49.1552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_57_115",
    x1: 31.5901,
    y1: 27.3632,
    x2: 121.635,
    y2: 48.6299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_57_115",
    x1: 31.9388,
    y1: 27.2767,
    x2: 120.123,
    y2: 48.1045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_57_115",
    x1: 32.2874,
    y1: 27.1902,
    x2: 118.613,
    y2: 47.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_57_115",
    x1: 32.6362,
    y1: 27.1044,
    x2: 117.103,
    y2: 47.0531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_57_115",
    x1: 32.9849,
    y1: 27.0179,
    x2: 115.593,
    y2: 46.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_57_115",
    x1: 33.3332,
    y1: 26.9317,
    x2: 114.083,
    y2: 46.0031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_57_115",
    x1: 33.6815,
    y1: 26.8441,
    x2: 112.574,
    y2: 45.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_57_115",
    x1: 34.0296,
    y1: 26.7583,
    x2: 111.066,
    y2: 44.9534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_57_115",
    x1: 34.3782,
    y1: 26.6725,
    x2: 109.558,
    y2: 44.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_57_115",
    x1: 22.0137,
    y1: 62.8895,
    x2: 112.339,
    y2: 7.40508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_57_115",
    x1: 22.329,
    y1: 62.5916,
    x2: 111.023,
    y2: 8.11031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_57_115",
    x1: 22.6452,
    y1: 62.2968,
    x2: 109.706,
    y2: 8.81813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_57_115",
    x1: 22.9609,
    y1: 61.9994,
    x2: 108.391,
    y2: 9.52335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_57_115",
    x1: 23.2761,
    y1: 61.7046,
    x2: 107.075,
    y2: 10.2312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_57_115",
    x1: 23.5909,
    y1: 61.4072,
    x2: 105.76,
    y2: 10.9364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_57_115",
    x1: 23.906,
    y1: 61.1119,
    x2: 104.444,
    y2: 11.6417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_57_115",
    x1: 24.2212,
    y1: 60.817,
    x2: 103.129,
    y2: 12.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_57_115",
    x1: 24.5374,
    y1: 60.5197,
    x2: 101.814,
    y2: 13.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_57_115",
    x1: 24.8525,
    y1: 60.2248,
    x2: 100.5,
    y2: 13.7574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_57_115",
    x1: 25.1678,
    y1: 59.9295,
    x2: 99.1851,
    y2: 14.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_57_115",
    x1: 25.4815,
    y1: 59.6321,
    x2: 97.8707,
    y2: 15.1679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_57_115",
    x1: 25.7971,
    y1: 59.3373,
    x2: 96.5581,
    y2: 15.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_57_115",
    x1: 26.1124,
    y1: 59.042,
    x2: 95.2453,
    y2: 16.5758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_57_115",
    x1: 26.4276,
    y1: 58.7446,
    x2: 93.9319,
    y2: 17.2811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_57_115",
    x1: 26.7424,
    y1: 58.4498,
    x2: 92.62,
    y2: 17.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_57_115",
    x1: 41.5663,
    y1: 92.6446,
    x2: 66.1783,
    y2: -10.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_57_115",
    x1: 41.7106,
    y1: 92.2251,
    x2: 65.8779,
    y2: -9.30171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_57_115",
    x1: 41.8539,
    y1: 91.8038,
    x2: 65.5764,
    y2: -7.85459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_57_115",
    x1: 41.9987,
    y1: 91.384,
    x2: 65.2767,
    y2: -6.40638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_57_115",
    x1: 42.1419,
    y1: 90.9623,
    x2: 64.9752,
    y2: -4.95961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_57_115",
    x1: 42.2862,
    y1: 90.5429,
    x2: 64.6758,
    y2: -3.51176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_57_115",
    x1: 42.431,
    y1: 90.123,
    x2: 64.3744,
    y2: -2.06533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_57_115",
    x1: 42.5735,
    y1: 89.7017,
    x2: 64.0736,
    y2: -0.618934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_57_115",
    x1: 42.7178,
    y1: 89.2822,
    x2: 63.7746,
    y2: 0.828557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_57_115",
    x1: 42.8621,
    y1: 88.8628,
    x2: 63.4738,
    y2: 2.27422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_57_115",
    x1: 43.005,
    y1: 88.4411,
    x2: 63.1734,
    y2: 3.71951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_57_115",
    x1: 43.149,
    y1: 88.022,
    x2: 62.8734,
    y2: 5.16517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_57_115",
    x1: 43.2934,
    y1: 87.6025,
    x2: 62.5715,
    y2: 6.60827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_57_115",
    x1: 43.4363,
    y1: 87.1812,
    x2: 62.2726,
    y2: 8.05248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_57_115",
    x1: 43.5802,
    y1: 86.7617,
    x2: 61.9729,
    y2: 9.49741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_57_115",
    x1: 43.7246,
    y1: 86.3426,
    x2: 61.6725,
    y2: 10.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_57_115",
    x1: 76.3517,
    y1: 99.8037,
    x2: 20.4562,
    y2: 9.51858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_57_115",
    x1: 76.2864,
    y1: 99.417,
    x2: 21.401,
    y2: 10.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_57_115",
    x1: 76.2211,
    y1: 99.0308,
    x2: 22.3458,
    y2: 12.0063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_57_115",
    x1: 76.1557,
    y1: 98.6441,
    x2: 23.2906,
    y2: 13.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_57_115",
    x1: 76.0903,
    y1: 98.2579,
    x2: 24.2332,
    y2: 14.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_57_115",
    x1: 76.0253,
    y1: 97.8717,
    x2: 25.1784,
    y2: 15.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_57_115",
    x1: 75.9626,
    y1: 97.485,
    x2: 26.1206,
    y2: 16.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_57_115",
    x1: 75.8973,
    y1: 97.0988,
    x2: 27.0654,
    y2: 18.2225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_57_115",
    x1: 75.832,
    y1: 96.7126,
    x2: 28.0076,
    y2: 19.4643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_57_115",
    x1: 75.7667,
    y1: 96.3264,
    x2: 28.9529,
    y2: 20.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_57_115",
    x1: 75.7012,
    y1: 95.9402,
    x2: 29.895,
    y2: 21.9484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_57_115",
    x1: 75.6358,
    y1: 95.554,
    x2: 30.837,
    y2: 23.1902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_57_115",
    x1: 75.573,
    y1: 95.1678,
    x2: 31.7792,
    y2: 24.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_57_115",
    x1: 75.5077,
    y1: 94.7821,
    x2: 32.722,
    y2: 25.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_57_115",
    x1: 75.4424,
    y1: 94.3964,
    x2: 33.6642,
    y2: 26.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_57_115",
    x1: 75.3771,
    y1: 94.0103,
    x2: 34.6064,
    y2: 28.1522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_57_115",
    x1: 105.991,
    y1: 80.1744,
    x2: 2.92308,
    y2: 55.8315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_57_115",
    x1: 105.803,
    y1: 79.9605,
    x2: 4.59555,
    y2: 56.0557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_57_115",
    x1: 105.614,
    y1: 79.7454,
    x2: 6.26718,
    y2: 56.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_57_115",
    x1: 105.425,
    y1: 79.5307,
    x2: 7.93965,
    y2: 56.5062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_57_115",
    x1: 105.236,
    y1: 79.3168,
    x2: 9.61001,
    y2: 56.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_57_115",
    x1: 105.047,
    y1: 79.1021,
    x2: 11.281,
    y2: 56.9575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_57_115",
    x1: 104.859,
    y1: 78.8882,
    x2: 12.9526,
    y2: 57.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_57_115",
    x1: 104.67,
    y1: 78.6732,
    x2: 14.6236,
    y2: 57.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_57_115",
    x1: 104.482,
    y1: 78.4596,
    x2: 16.2931,
    y2: 57.6315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_57_115",
    x1: 104.292,
    y1: 78.2446,
    x2: 17.963,
    y2: 57.8567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_57_115",
    x1: 104.104,
    y1: 78.031,
    x2: 19.633,
    y2: 58.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_57_115",
    x1: 103.915,
    y1: 77.816,
    x2: 21.3029,
    y2: 58.3062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_57_115",
    x1: 103.727,
    y1: 77.602,
    x2: 22.9721,
    y2: 58.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_57_115",
    x1: 103.539,
    y1: 77.3881,
    x2: 24.6408,
    y2: 58.7542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_57_115",
    x1: 103.351,
    y1: 77.1742,
    x2: 26.3093,
    y2: 58.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_57_115",
    x1: 103.162,
    y1: 76.9595,
    x2: 27.9781,
    y2: 59.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_57_115",
    x1: 113.122,
    y1: 45.2536,
    x2: 22.8078,
    y2: 100.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_57_115",
    x1: 112.966,
    y1: 45.2484,
    x2: 24.2827,
    y2: 99.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_57_115",
    x1: 112.811,
    y1: 45.2443,
    x2: 25.7579,
    y2: 98.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_57_115",
    x1: 112.656,
    y1: 45.2396,
    x2: 27.2333,
    y2: 97.7105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_57_115",
    x1: 112.502,
    y1: 45.2345,
    x2: 28.7081,
    y2: 96.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_57_115",
    x1: 112.346,
    y1: 45.2293,
    x2: 30.1829,
    y2: 95.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_57_115",
    x1: 112.191,
    y1: 45.2257,
    x2: 31.6583,
    y2: 94.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_57_115",
    x1: 112.035,
    y1: 45.2205,
    x2: 33.1305,
    y2: 93.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_57_115",
    x1: 111.882,
    y1: 45.2154,
    x2: 34.6054,
    y2: 92.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_57_115",
    x1: 111.726,
    y1: 45.2107,
    x2: 36.078,
    y2: 91.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_57_115",
    x1: 111.57,
    y1: 45.2056,
    x2: 37.5529,
    y2: 90.6724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_57_115",
    x1: 111.418,
    y1: 45.2004,
    x2: 39.0261,
    y2: 89.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_57_115",
    x1: 111.262,
    y1: 45.1968,
    x2: 40.4984,
    y2: 88.6635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_57_115",
    x1: 111.106,
    y1: 45.1916,
    x2: 41.9707,
    y2: 87.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_57_115",
    x1: 110.953,
    y1: 45.1864,
    x2: 43.4408,
    y2: 86.6556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_57_115",
    x1: 110.797,
    y1: 45.1813,
    x2: 44.9131,
    y2: 85.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_57_115",
    x1: 93.57,
    y1: 15.4982,
    x2: 68.9581,
    y2: 118.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_57_115",
    x1: 93.5857,
    y1: 15.6179,
    x2: 69.4182,
    y2: 117.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_57_115",
    x1: 93.602,
    y1: 15.738,
    x2: 69.8792,
    y2: 115.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_57_115",
    x1: 93.6186,
    y1: 15.8574,
    x2: 70.3406,
    y2: 113.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_57_115",
    x1: 93.6346,
    y1: 15.9771,
    x2: 70.8014,
    y2: 111.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_57_115",
    x1: 93.6512,
    y1: 16.0969,
    x2: 71.2616,
    y2: 110.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_57_115",
    x1: 93.6672,
    y1: 16.2166,
    x2: 71.7224,
    y2: 108.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_57_115",
    x1: 93.6833,
    y1: 16.3364,
    x2: 72.1831,
    y2: 106.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_57_115",
    x1: 93.7002,
    y1: 16.455,
    x2: 72.643,
    y2: 104.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_57_115",
    x1: 93.7166,
    y1: 16.5744,
    x2: 73.1042,
    y2: 103.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_57_115",
    x1: 93.7326,
    y1: 16.6942,
    x2: 73.5642,
    y2: 101.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_57_115",
    x1: 93.7489,
    y1: 16.8139,
    x2: 74.0242,
    y2: 99.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_57_115",
    x1: 93.766,
    y1: 16.9326,
    x2: 74.4846,
    y2: 97.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_57_115",
    x1: 93.7819,
    y1: 17.0519,
    x2: 74.9441,
    y2: 96.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_57_115",
    x1: 93.7986,
    y1: 17.1706,
    x2: 75.4045,
    y2: 94.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_57_115",
    x1: 93.815,
    y1: 17.29,
    x2: 75.8642,
    y2: 92.7005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_57_115",
    x1: 47.7154,
    y1: 18.5704,
    x2: 88.4829,
    y2: 84.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_57_115",
    x1: 62.1619,
    y1: 9.6234,
    x2: 102.934,
    y2: 75.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_57_115",
    x1: 34.3787,
    y1: 26.6725,
    x2: 109.558,
    y2: 44.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_57_115",
    x1: 26.7424,
    y1: 58.4498,
    x2: 92.62,
    y2: 17.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_57_115",
    x1: 43.7246,
    y1: 86.3426,
    x2: 61.6725,
    y2: 10.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_57_115",
    x1: 75.3776,
    y1: 94.0103,
    x2: 34.6069,
    y2: 28.1522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_57_115",
    x1: 103.162,
    y1: 76.9595,
    x2: 27.9781,
    y2: 59.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_57_115",
    x1: 110.797,
    y1: 45.1813,
    x2: 44.9136,
    y2: 85.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_57_115",
    x1: 93.8155,
    y1: 17.29,
    x2: 75.8647,
    y2: 92.7005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6EB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F9C62F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.146db3878c19eba0017966bda9e986fc.svg";
export { ForwardRef as ReactComponent };